module.exports = __webpack_public_path__ + "static/media/icon_money.18bf8878.svg";